exports.imgUrl = "https://ybites.sgp1.digitaloceanspaces.com";
